import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withKeys as _withKeys, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd05f3ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "paging_container" }
const _hoisted_2 = {
  key: 0,
  class: "list_info"
}
const _hoisted_3 = { class: "OrderSearch_Table" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "isActivePC OrderSearch_Table_Sticky_Sell1 Sticky_Head" }, " 選択 ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "OrderSearch_Table_Small isActivePC OrderSearch_Table_Sticky_Sell2 Sticky_Head" }, " 詳細 ", -1))
const _hoisted_6 = { class: "isActivePC OrderSearch_Table_Sticky_Sell3 Sticky_Head OrderSearch_Table_CdArea th_sort" }
const _hoisted_7 = { class: "isActivePC OrderSearch_Table_SyosiInfo OrderSearch_Table_Sticky_Sell4 Sticky_Head th_sort" }
const _hoisted_8 = {
  class: "isActiveSP OrderSearch_Table_SyosiInfo OrderSearch_Table_Sticky_Sell3 Sticky_Head th_sort",
  style: {"min-width":"100px"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "isActivePC th_sort" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "isActivePC" }, "カート追加", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "isActivePC OrderSearch_Table_Medium" }, "備考", -1))
const _hoisted_15 = { class: "isActivePC OrderSearch_Table_Medium th_sort" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "isActivePC OrderSearch_Table_Sticky_Sell1" }
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = { class: "OrderSearch_Table_Small isActivePC OrderSearch_Table_Sticky_Sell2" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  class: "isActivePC OrderSearch_Table_Sticky_Sell3 OrderSearch_Table_CdArea delimiter Text_Left",
  style: {"min-width":"100px"}
}
const _hoisted_22 = { class: "isActivePC OrderSearch_Table_SyosiInfo OrderSearch_Table_Sticky_Sell4 delimiter Text_Left" }
const _hoisted_23 = { class: "isActiveSP isActiveSP_Contents OrderSearch_Table_SyosiInfo OrderSearch_Table_Sticky_Sell3 Text_Left" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = { class: "isActivePC delimiter" }
const _hoisted_27 = { class: "Add_Border-R" }
const _hoisted_28 = { class: "isActivePC" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "isActivePC" }
const _hoisted_32 = ["onUpdate:modelValue", "onFocus", "onChange", "onBlur"]
const _hoisted_33 = { class: "isActivePC" }
const _hoisted_34 = { class: "OrderSearch_Table_Medium isActivePC" }
const _hoisted_35 = { class: "isActivePC OrderSearch_Table_Medium delimiter" }
const _hoisted_36 = { class: "isActivePC OrderSearch_Table_Medium" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = {
  key: 0,
  class: "ResultMessageNull"
}

import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { onBeforeRouteLeave, useRouter } from "vue-router";
import { useStore } from "vuex";
import OrderHeader from "../components/OrderHeader.vue";
import OrderFooter from "../components/OrderFooter.vue";
import PankuzuHeader from "../components/PankuzuHeader.vue";
import OverlayCart from "../components/OverlayCart.vue";
import ModalListGroup, { Lists } from "@/components/modal/ModalListGroup.vue";
import { Notyf } from "notyf";
import Paginate from "vuejs-paginate-next";
import { ZaikoData, NormalCartItem } from "../types/zaiko";
import axios, { AxiosResponse } from "axios";
import { NormalItem, ResOfCartData } from "@/types/order";
import common from "../common";
import ModalCartAlert from "@/components/modal/ModalCartAlert.vue";

// ナビゲーションガード---------------------------------------------
// 未更新データがある場合、画面遷移前に確認する

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderSearch',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  emits: ["showGlobalHeader", "toggleGlobalHeader"],
  setup(__props) {

onBeforeRouteLeave((to, from) => {
  let hasUpdatedData = checkHasUpdated();
  let isConfirm = false;
  if (hasUpdatedData) {
    isConfirm = confirm("カート未追加のデータが削除されますがよろしいですか？");
  } else {
    isConfirm = true;
  }

  if (!isConfirm) return false;
});

// 初期設定---------------------------------------------------------
const notyf = new Notyf();
const router = useRouter();

//propsの定義
const props = __props;
//Emitの定義


// ストア関連
const store = useStore();
// ストアの初期化
store.commit("search/clearAuthData");

// OrderHeaderに渡すフラグ--------------------------
let searchAreaToggle: boolean = true;

// OrderFooterに渡すフラグ--------------------------
let fromOrderSearch: boolean = true;

//ぱんくずヘッダー
const currentPathList = [
  { name: "受注入力" },
  { name: "通常受注" },
  { name: "通常入力" },
];

// 全体で使用する変数--------------------------------------------
// ソート関連
let sortInfo = ref({
  sortItem: "",
  isKoujun: false,
});
let isSorting = ref(false);

// エンターキーでの移動用-------------------------------------
const { creatMoveWithEnterElms, moveNext, movePrev } = common();
let moveWithEnterElms = ref([] as HTMLElement[]);

// リスト一覧関連--------------------------------------------
const orderHeader = ref();
const listModalVisible = ref(false);
const isListSearch = ref(false);
let listSyosi = ref({} as Lists);
const showListModal = () => {
  listModalVisible.value = true;
};
const selectList = (list: Lists) => {
  listModalVisible.value = false;
  // 表示されている検索条件の削除
  orderHeader.value.resetConditions();
  // ストアの初期化
  store.commit("search/clearAuthData");
  // ページの初期化
  currentPage.value = 1;
  // ソートの初期化
  sortInfo.value.sortItem = "";
  sortInfo.value.isKoujun = false;
  isSorting.value = false;

  isListSearch.value = true;
  listSyosi.value = list;
  getZaikoData();
};

// 検索ヘッダ関連------------------------------------------------------------
//簡易検索
let isActive_KaniFlg = ref(false);
const changeKaniFlg = (KaniFlg: boolean): void => {
  isActive_KaniFlg.value = KaniFlg;
};

//詳細検索
let isActive_SyosaiFlg = ref(true);
const changeSyosaiFlg = (SyosaiFlg: boolean): void => {
  isActive_SyosaiFlg.value = SyosaiFlg;
};
let isOpentoggleArea = ref<boolean>(true);
const changeToggleArea = (toggleAreaFlg: boolean): void => {
  isOpentoggleArea.value = toggleAreaFlg;
};
// 検索ボタンクリック時
const onSearch = () => {
  // リスト一覧情報の削除
  isListSearch.value = false;
  listSyosi.value = {} as Lists;

  store.commit("search/resetPage");
  currentPage.value = 1;
  getZaikoData();
};
//テーブルの高さ判定
const tableHeight = () => {
  if (isOpentoggleArea.value) {
    //詳細ヘッダが空いているときのみテーブルを短くする
    return "OrderSearch_TableContainer_Short";
  } else {
    //その他
    return "OrderSearch_TableContainer_Long";
  }
};

//別タブで詳細表示---------------------------------
const openDetailTab = (isbn: string | null): void => {
  const targetIsbn = typeof isbn === "string" ? isbn : "";
  if (targetIsbn === "") {
    notyf.error("詳細情報が見つかりません");
    return;
  }
  let resolvedRoute = router.resolve({
    name: "OrderSearchDetail",
    params: { id: targetIsbn },
  });
  window.open(
    resolvedRoute.href,
    "_blank",
    "width=800,height=390,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
      (window.screen.width - 1000) / 2 +
      ",top=" +
      (window.screen.height - 650) / 2
  );
};

// テーブル表示項目------------------------------------------------------------------
// 1ページあたりの表示数
let numberOfDisplay = 250;
let search_result = ref<NormalCartItem[]>([]);

// 日付のフォーマットを変更する
const formatDate = (date: string | null) => {
  if (typeof date === "string") {
    const targetDate = new Date(date);
    const year = targetDate.getFullYear();
    const month = targetDate.getMonth() + 1;
    const day = targetDate.getDate();
    return year + "/" + month + "/" + day;
  } else {
    return null;
  }
};

// 全選択-------------------------------------------------------------------------------
let isActiveSelectAll = ref(false);
let selectAll = (selectFlg: boolean) => {
  isActiveSelectAll.value = selectFlg;
  search_result.value.forEach((result): void => {
    if (selectFlg) {
      result.selectFlg = true;
    } else {
      result.selectFlg = false;
    }
  });
};

// データ取得---------------------------------------------------------------

// 1ページあたりの表示数をセット
const setNumberOfDisplay = () => {
  store.commit("search/setNumberOfDisplay", numberOfDisplay);
};
setNumberOfDisplay();

// データ検索・取得
const getZaikoData = async () => {
  search_result.value.splice(0);
  // リスト一覧が選択された場合の検索
  if (isListSearch.value) {
    if (isSorting.value === true) {
      await store.dispatch("search/sortListZaiko", {
        sortItem: sortInfo.value.sortItem,
        isKoujun: sortInfo.value.isKoujun,
        listId: listSyosi.value.listId,
      });
    } else {
      await store.dispatch("search/searchListZaiko", {
        listId: listSyosi.value.listId,
      });
    }
  }
  // 通常の検索
  else {
    if (isSorting.value === true) {
      await store.dispatch("search/sortZaiko", {
        sortItem: sortInfo.value.sortItem,
        isKoujun: sortInfo.value.isKoujun,
      });
    } else {
      await store.dispatch("search/searchZaiko");
    }
  }

  const res = store.getters["search/getZaikoData"];
  res.syosiList.forEach((syosi: ZaikoData) => {
    let data = { ...syosi, selectFlg: false, updatedFlg: false, orderNum: 1 };
    search_result.value.push(data);
  });
  numberOfTotalData.value = res.size;
  firstCount.value = res.firstCount;
  finalCount.value = res.finalCount;
  getTotalPage();
  // エンターキー移動用要素一覧を作成
  moveWithEnterElms.value = await creatMoveWithEnterElms();
};
// 初期表示は検索結果なしにする
// getZaikoData();

// カート追加関連-------------------------------------------------------------------
let holdQuantity = 0;
const focusQuantity = (e: any, index: number) => {
  holdQuantity = Number(e.target.value);
  search_result.value[index].orderNum = "";
};
const blurQuantity = (e: any, index: number) => {
  if (e.target.value === "") {
    search_result.value[index].orderNum = holdQuantity;
  }
  holdQuantity = 0;
};
const validateQuantity = (e: any, index: number) => {
  //符号無し整数を判定
  if (!e.target.value.match(/^[0-9]+$/)) {
    search_result.value[index].orderNum = 0;
  }
  // 正しい数字だったら変更フラグを立てる
  else {
    search_result.value[index].updatedFlg = true;
    search_result.value[index].selectFlg = true;
  }
};
const addOrderToCart = async (syosi?: NormalCartItem) => {
  try {
    let cartItem: { janCd: string | null; quantity: number }[] = [];
    let hasCartItem = false;
    let hasNoQuantity = false;
    let zeppanItem = [];
    let titleMesage = "";
    //テーブル項目から個別に追加した場合
    if (syosi) {
      if (Number(syosi.orderNum) === 0) {
        hasNoQuantity = true;
      } else {
        hasCartItem = true;
        cartItem.push({
          janCd: syosi.janCd,
          quantity: syosi.orderNum as number,
        });
        titleMesage = `『${syosi.title}』を`;
        // 絶版・全量廃棄が含まれる場合配列に格納
        if (syosi.zsId === "34" || syosi.cutting === "4:全量廃棄") {
          zeppanItem.push(syosi);
        }
      }
    } else {
      //フッダーから一括追加した場合
      search_result.value.forEach((result) => {
        if (Number(result.orderNum) === 0 && result.selectFlg) {
          hasNoQuantity = true;
        } else if (Number(result.orderNum) > 0 && result.selectFlg) {
          hasCartItem = true;
          cartItem.push({
            janCd: result.janCd,
            quantity: result.orderNum as number,
          });
          // 絶版・全量廃棄が含まれる場合配列に格納
          if (result.zsId === "34" || result.cutting === "4:全量廃棄") {
            zeppanItem.push(result);
          }
        }
      });
    }

    if (!hasCartItem) {
      notyf.error("追加する製品が未設定です");
      return;
    } else if (hasNoQuantity) {
      notyf.error("数量を設定してください");
      return;
    } else if (zeppanItem.length > 0) {
      // 絶版・全量廃棄が含まれる場合アラートモーダル表示
      zeppanItems.value = zeppanItem;
      isTandoku.value = syosi ? true : false;
      tandokuSyosiInfo.value = syosi ? syosi : undefined;
      alertModalVisible.value = true;
      return;
    }

    const res = await axios.post(
      `${store.getters["getBaseUrl"]}/chumon/cartAddNormalChumon`,
      cartItem,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    notyf.success(`${titleMesage}カートに製品を追加しました`);
    getCartData();
    getCartItem();
    // カートに追加したデータの選択、数量、更新フラグをリセット
    if (syosi) {
      syosi.selectFlg = false;
      syosi.updatedFlg = false;
      syosi.orderNum = 1;
    } else {
      search_result.value.forEach((result) => {
        if (result.selectFlg) {
          result.selectFlg = false;
          result.updatedFlg = false;
          result.orderNum = 1;
        }
      });
    }
  } catch (error) {
    console.log(error);
  }
};

let updateNum = (orderNum: number): void => {
  search_result.value.forEach((result: NormalCartItem): void => {
    if (result.selectFlg) {
      result.updatedFlg = true;
      result.orderNum = orderNum;
      result.selectFlg = true;
    }
  });
};

// カート追加時アラート関連----------------------------
const alertModalVisible = ref(false); // モーダル開閉制御
const zeppanItems = ref([] as NormalCartItem[]); // 絶版商品一覧
const isTandoku = ref(false); // 単独追加:true,複数追加:false
const tandokuSyosiInfo = ref({} as NormalCartItem | undefined); // （単独追加の場合）選択された書誌情報を格納
// モーダルクローズ
const closeAlertModal = () => {
  alertModalVisible.value = false;
};
// アラートconfirm後のカート追加処理
const confirmedAlert = async (
  isConfirm: boolean,
  isTandoku: boolean,
  tandokuSyosiInfo: NormalCartItem | undefined
) => {
  let titleMesage = "";
  let cartItem: { janCd: string | null; quantity: number }[] = [];
  // カート追加する商品の抽出
  // 絶版・全量廃棄商品を除外する場合
  if (isConfirm) {
    // 複数追加の場合（単独追加時の処理なし）
    if (!isTandoku) {
      search_result.value.forEach((result) => {
        if (
          result.selectFlg &&
          !(result.zsId === "34" || result.cutting === "4:全量廃棄")
        ) {
          cartItem.push({
            janCd: result.janCd,
            quantity: result.orderNum as number,
          });
        }
      });
    }
  }
  // 除外しない場合
  else {
    // 単独追加の場合
    if (isTandoku) {
      cartItem.push({
        janCd: tandokuSyosiInfo?.janCd as string,
        quantity: tandokuSyosiInfo?.orderNum as number,
      });
      titleMesage = `『${tandokuSyosiInfo?.title}』を`;
    }
    // 複数追加の場合
    else {
      search_result.value.forEach((result) => {
        if (result.selectFlg) {
          cartItem.push({
            janCd: result.janCd,
            quantity: result.orderNum as number,
          });
        }
      });
    }
  }
  // カート追加処理
  const addCart = async () => {
    try {
      await axios.post(
        `${store.getters["getBaseUrl"]}/chumon/cartAddNormalChumon`,
        cartItem,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      notyf.success(`${titleMesage}カートに製品を追加しました`);
      getCartData();
      getCartItem();
    } catch (error) {
      console.log(error);
      alert("カート追加に失敗しました");
    }
  };
  if (cartItem.length > 0) {
    await addCart();
  }
  // カートに追加したデータの選択、数量、更新フラグをリセット
  if (isTandoku) {
    const targetIndex = search_result.value.findIndex((result) => {
      return result.janCd === tandokuSyosiInfo?.janCd;
    });
    if (targetIndex > -1) {
      search_result.value[targetIndex].selectFlg = false;
      search_result.value[targetIndex].updatedFlg = false;
      search_result.value[targetIndex].orderNum = 1;
    }
  } else {
    search_result.value.forEach((result) => {
      if (result.selectFlg) {
        result.selectFlg = false;
        result.updatedFlg = false;
        result.orderNum = 1;
      }
    });
  }
};

//カートに入った商品数の取得(ヘッダのカートアイコン用)-------------
const getCartData = async () => {
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/chumon/cartData?mode=0`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    const cartNum = res.data.length;
    store.commit("search/setCartNormalNum", cartNum);
  } catch (error) {
    console.log(error);
  }
};
getCartData();

// ページネーション関連処理-----------------------------------------
// 取得データ合計
let numberOfTotalData = ref(0);
// 1ページあたりの表示データ数
let dataPerPage = numberOfDisplay;
//表示中のページ範囲
let firstCount = ref(0);
let finalCount = ref(0);
// 総ページ数
const numberOfTotalPage = ref(0);
// 現在のページ数
const currentPage = ref(1);
const getTotalPage = () => {
  numberOfTotalPage.value = Math.ceil(numberOfTotalData.value / dataPerPage);
};
const onClickPage = (newPage: number) => {
  let hasUpdatedData = checkHasUpdated();
  let isConfirm = false;
  if (hasUpdatedData) {
    isConfirm = confirm("カート未追加のデータが削除されますがよろしいですか？");
  } else {
    isConfirm = true;
  }

  if (isConfirm) {
    currentPage.value = newPage;
    store.commit("search/setPageNumber", currentPage.value);
    getZaikoData();
  }
};
// 未更新のデータがないかチェック
const checkHasUpdated = () => {
  let hasUpdatedData = false;
  search_result.value.forEach((result) => {
    if (result.updatedFlg || result.selectFlg) {
      hasUpdatedData = true;
    }
  });
  return hasUpdatedData;
};

// テーブルソート処理--------------------------------------------------------------------------------------
const sortTable = async (sortItem: string) => {
  isSorting.value = true;
  if (sortInfo.value.sortItem === sortItem) {
    sortInfo.value.isKoujun = !sortInfo.value.isKoujun;
  } else {
    sortInfo.value.isKoujun = false;
    // 別のソートに切り替えた時ページネーションを1にする
    currentPage.value = 1;
    store.commit("search/setPageNumber", currentPage.value);
  }
  sortInfo.value.sortItem = sortItem;

  getZaikoData();
};

const showSortSymbol = (sortItem: string) => {
  if (
    isSorting.value &&
    sortInfo.value.sortItem === sortItem &&
    sortInfo.value.isKoujun
  ) {
    return "▼";
  } else if (
    isSorting.value &&
    sortInfo.value.sortItem === sortItem &&
    !sortInfo.value.isKoujun
  ) {
    return "▲";
  } else {
    return "";
  }
};

//ダウンロード------------------------------------------------
let isLoading = ref(false);
const getCsvData = () => {
  console.log("download....");
};

// カート内容確認オーバーレイ関連---------------------------------
// 開閉関連
const isShowCartOverlay = ref(false);
const openCartNormal = () => {
  isShowCartOverlay.value = true;
};
// カート照会画面へのルーティング
const transNormalCart = () => {
  router.push("/cartNormal");
};
// カート内容取得
let cartItem = ref<NormalItem[]>([
  {
    juchuCartId: -1,
    janCd: "",
    syosiCd: "",
    title: "",
    quantity: -1,
    juchuKbn: null,
    hontaiPrice: -1,
    hold: false,
    availableAmount: -1,
    torioki: -1,
    inputSum: null,
    holdSum: null,
    zsName: "",
    selectFlg: false,
  },
]);
//通常カート情報の取得
const getCartItem = async () => {
  cartItem.value.splice(0);
  cartItem.value.push({
    juchuCartId: -1,
    janCd: "",
    syosiCd: "",
    title: "",
    quantity: -1,
    juchuKbn: null,
    hontaiPrice: -1,
    hold: false,
    availableAmount: -1,
    torioki: -1,
    inputSum: null,
    holdSum: null,
    zsName: "",
    selectFlg: false,
  });
  try {
    let res: AxiosResponse<ResOfCartData[]>;
    res = await axios.get(
      `${store.getters["getBaseUrl"]}/chumon/cartData?mode=0`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );

    res.data.forEach((data: ResOfCartData, dataIndex) => {
      // 書誌データの代入
      let pushSyosi = {} as NormalItem;
      Object.keys(cartItem.value[0]).forEach((syosiKey: keyof NormalItem) => {
        Object.keys(data).forEach((dataKey: keyof ResOfCartData) => {
          if (syosiKey === dataKey) {
            pushSyosi[syosiKey] = data[dataKey];
          }
        });
      });
      // チェックボックス用プロパティの追加
      pushSyosi.selectFlg = false;
      cartItem.value.push(pushSyosi);
    });
    cartItem.value.splice(0, 1);
  } catch (error) {
    alert("カートデータの取得に失敗しました");
    console.log(error);
  }
};
getCartItem();

// キークリック関連------------------------
const onKeyDown = (e: any) => {
  // console.log(e);
  if (e.key === "F8" && !e.altKey && !e.ctrlKey && !e.shiftKey) {
    e.preventDefault();
    setTimeout(() => {
      addOrderToCart();
    }, 100);
  }
};
onMounted(() => {
  document.addEventListener("keydown", onKeyDown);
});
onBeforeUnmount(() => {
  document.removeEventListener("keydown", onKeyDown);
});

// 他---------------------------------------------
// 取置がクリックされた時に別タブを開く
const openToriokiDetail = async (janCd: string): Promise<void> => {
  let resolvedRoute = router.resolve({
    name: "ToriokiDetail",
    params: { janCd: janCd },
  });
  window.open(
    resolvedRoute.href,
    "_blank",
    "width=1200,height=300,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
      (window.screen.width - 1000) / 2 +
      ",top=" +
      (window.screen.height - 650) / 2
  );
};
// カート確認画面から削除されたとき情報を取得し直す
const reloadCart = () => {
  getCartItem();
  getCartData();
};
// 選択中の書誌点数を数える
const countSelectedSyosi = computed(() => {
  let countNum = 0;
  search_result.value.forEach((result) => {
    if (result.selectFlg) countNum++;
  });
  return countNum.toLocaleString();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["OrderSearch", {
      Show_KaniSearch: _unref(isActive_KaniFlg),
      Show_SyosaiSearch: _unref(isActive_SyosaiFlg),
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
  }, [
    (isShowCartOverlay.value)
      ? (_openBlock(), _createBlock(OverlayCart, {
          key: 0,
          "normal-cart-data": _unref(cartItem),
          onTransNormalCart: transNormalCart,
          onOnClose: _cache[0] || (_cache[0] = ($event: any) => (isShowCartOverlay.value = false)),
          onReloadCart: reloadCart
        }, null, 8, ["normal-cart-data"]))
      : _createCommentVNode("", true),
    (listModalVisible.value)
      ? (_openBlock(), _createBlock(ModalListGroup, {
          key: 1,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (listModalVisible.value = false)),
          onSelectList: selectList
        }))
      : _createCommentVNode("", true),
    (alertModalVisible.value)
      ? (_openBlock(), _createBlock(ModalCartAlert, {
          key: 2,
          zeppanItems: zeppanItems.value,
          isTandoku: isTandoku.value,
          tandokuSyosiInfo: tandokuSyosiInfo.value,
          onExecute: confirmedAlert,
          onClose: closeAlertModal
        }, null, 8, ["zeppanItems", "isTandoku", "tandokuSyosiInfo"]))
      : _createCommentVNode("", true),
    _createVNode(PankuzuHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      currentPathList: currentPathList
    }, null, 8, ["isActive_SidebarFlg"]),
    _createVNode(OrderHeader, {
      ref_key: "orderHeader",
      ref: orderHeader,
      isActive_KaniFlg: _unref(isActive_KaniFlg),
      isActive_SyosaiFlg: _unref(isActive_SyosaiFlg),
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      searchAreaToggle: _unref(searchAreaToggle),
      onChangeKaniFlg: changeKaniFlg,
      onChangeSyosaiFlg: changeSyosaiFlg,
      onOnSearch: onSearch,
      onChangeToggleArea: changeToggleArea,
      onOpenCartNormal: openCartNormal,
      onShowList: showListModal
    }, null, 8, ["isActive_KaniFlg", "isActive_SyosaiFlg", "isActive_SidebarFlg", "searchAreaToggle"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Paginate), {
        "page-count": numberOfTotalPage.value,
        "hide-prev-next": true,
        "page-range": 3,
        "prev-text": '<',
        "next-text": '>',
        "container-class": 'pagination',
        "page-class": 'page-item',
        "page-link-class": 'page-item--link',
        "active-class": 'page-item--active',
        "click-handler": onClickPage,
        "force-page": currentPage.value
      }, null, 8, ["page-count", "force-page"]),
      _withDirectives(_createElementVNode("span", { class: "paging_result" }, " 検索結果：" + _toDisplayString(_unref(numberOfTotalData)) + "件/" + _toDisplayString(_unref(firstCount)) + "～" + _toDisplayString(_unref(finalCount)) + "件を表示", 513), [
        [_vShow, _unref(search_result).length]
      ]),
      (isListSearch.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "リスト「" + _toDisplayString(_unref(listSyosi).listName) + "」を表示中", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["OrderSearch_MainArea", tableHeight()])
    }, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("th", _hoisted_6, [
              _createElementVNode("p", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (sortTable('syosiCd')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("syosiCd")), 1),
                _createTextVNode("書誌CD ")
              ]),
              _createElementVNode("p", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (sortTable('syuppanSyosiCd')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("syuppanSyosiCd")), 1),
                _createTextVNode("出版社書誌CD ")
              ]),
              _createElementVNode("p", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (sortTable('janCd')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("janCd")), 1),
                _createTextVNode("ISBN13桁 ")
              ])
            ]),
            _createElementVNode("th", _hoisted_7, [
              _createElementVNode("p", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (sortTable('category')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("category")), 1),
                _createTextVNode("カテゴリ ")
              ]),
              _createElementVNode("p", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (sortTable('title')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("title")), 1),
                _createTextVNode("書誌名 ")
              ])
            ]),
            _createElementVNode("th", _hoisted_8, [
              _createElementVNode("p", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (sortTable('syosiCd')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("syosiCd")), 1),
                _createTextVNode("書誌CD ")
              ]),
              _createElementVNode("p", {
                onClick: _cache[8] || (_cache[8] = ($event: any) => (sortTable('syuppanSyosiCd')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("syuppanSyosiCd")), 1),
                _createTextVNode("出版社書誌CD ")
              ]),
              _createElementVNode("p", {
                onClick: _cache[9] || (_cache[9] = ($event: any) => (sortTable('janCd')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("janCd")), 1),
                _createTextVNode("ISBN13桁 書誌名 ")
              ])
            ]),
            _createElementVNode("th", {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (sortTable('availableAmount'))),
              class: "th_sort",
              style: {"min-width":"70px"}
            }, [
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("availableAmount")), 1),
              _createTextVNode("出荷"),
              _hoisted_9,
              _createTextVNode("可能数 ")
            ]),
            _createElementVNode("th", _hoisted_10, [
              _createElementVNode("p", {
                onClick: _cache[11] || (_cache[11] = ($event: any) => (sortTable('zaikoStatus')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("zaikoStatus")), 1),
                _createTextVNode("在庫 ")
              ]),
              _createElementVNode("p", {
                onClick: _cache[12] || (_cache[12] = ($event: any) => (sortTable('cutting')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("cutting")), 1),
                _createTextVNode("断裁 ")
              ])
            ]),
            _createElementVNode("th", {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (sortTable('inputSum'))),
              class: "th_sort",
              style: {"min-width":"70px"}
            }, [
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("inputSum")), 1),
              _createTextVNode("受注"),
              _hoisted_11,
              _createTextVNode("合計 ")
            ]),
            _createElementVNode("th", {
              onClick: _cache[14] || (_cache[14] = ($event: any) => (sortTable('holdSum'))),
              class: "th_sort",
              style: {"min-width":"70px"}
            }, [
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("holdSum")), 1),
              _createTextVNode("保留 ")
            ]),
            _createElementVNode("th", {
              onClick: _cache[15] || (_cache[15] = ($event: any) => (sortTable('returnItems'))),
              class: "th_sort"
            }, [
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("returnItems")), 1),
              _createTextVNode("返品 ")
            ]),
            _createElementVNode("th", {
              onClick: _cache[16] || (_cache[16] = ($event: any) => (sortTable('hontaiPrice'))),
              class: "th_sort"
            }, [
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("hontaiPrice")), 1),
              _createTextVNode("本体"),
              _hoisted_12,
              _createTextVNode("価格 ")
            ]),
            _createElementVNode("th", {
              onClick: _cache[17] || (_cache[17] = ($event: any) => (sortTable('torioki'))),
              class: "isActivePC th_sort"
            }, [
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("torioki")), 1),
              _createTextVNode("取置 ")
            ]),
            _hoisted_13,
            _createElementVNode("th", {
              onClick: _cache[18] || (_cache[18] = ($event: any) => (sortTable('series'))),
              class: "isActivePC th_sort"
            }, [
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("series")), 1),
              _createTextVNode("シリーズ名 ")
            ]),
            _hoisted_14,
            _createElementVNode("th", _hoisted_15, [
              _createElementVNode("p", {
                onClick: _cache[19] || (_cache[19] = ($event: any) => (sortTable('releaseDate')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("releaseDate")), 1),
                _createTextVNode("発売日 ")
              ]),
              _createElementVNode("p", {
                onClick: _cache[20] || (_cache[20] = ($event: any) => (sortTable('juhanDate')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("juhanDate")), 1),
                _createTextVNode("重版予定日 ")
              ]),
              _createElementVNode("p", {
                onClick: _cache[21] || (_cache[21] = ($event: any) => (sortTable('kaisoDate')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("kaisoDate")), 1),
                _createTextVNode("改装予定日 ")
              ])
            ]),
            _createElementVNode("th", {
              onClick: _cache[22] || (_cache[22] = ($event: any) => (sortTable('author'))),
              class: "isActivePC OrderSearch_Table_Medium th_sort"
            }, [
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("author")), 1),
              _createTextVNode("著者 ")
            ])
          ])
        ]),
        (_unref(search_result).length)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(search_result), (result, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: _normalizeClass({ updated: result.selectFlg })
                }, [
                  _createElementVNode("td", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      class: "OrderSearch_Table_Checkbox Move_With_Enter",
                      tabindex: "1",
                      type: "checkbox",
                      "onUpdate:modelValue": ($event: any) => ((result.selectFlg) = $event),
                      onKeydown: [
                        _cache[23] || (_cache[23] = _withKeys(_withModifiers(($event: any) => (_unref(moveNext)($event, _unref(moveWithEnterElms))), ["exact"]), ["enter"])),
                        _cache[24] || (_cache[24] = _withKeys(_withModifiers(($event: any) => (_unref(movePrev)($event, _unref(moveWithEnterElms))), ["shift"]), ["enter"]))
                      ]
                    }, null, 40, _hoisted_18), [
                      [_vModelCheckbox, result.selectFlg]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_19, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (openDetailTab(result.janCd)),
                      class: "OrderSearch_Table_Button Move_With_Enter",
                      tabindex: "2",
                      onKeydown: [
                        _cache[25] || (_cache[25] = _withKeys(_withModifiers(($event: any) => (_unref(moveNext)($event, _unref(moveWithEnterElms))), ["exact"]), ["enter"])),
                        _cache[26] || (_cache[26] = _withKeys(_withModifiers(($event: any) => (_unref(movePrev)($event, _unref(moveWithEnterElms))), ["shift"]), ["enter"]))
                      ]
                    }, " 参照 ", 40, _hoisted_20)
                  ]),
                  _createElementVNode("td", _hoisted_21, [
                    _createElementVNode("span", null, _toDisplayString(result.syosiCd), 1),
                    _createElementVNode("span", null, _toDisplayString(result.syuppanSyosiCd), 1),
                    _createElementVNode("span", null, _toDisplayString(result.janCd), 1)
                  ]),
                  _createElementVNode("td", _hoisted_22, [
                    _createElementVNode("span", null, _toDisplayString(result.category), 1),
                    _createElementVNode("span", null, _toDisplayString(result.title), 1)
                  ]),
                  _createElementVNode("td", _hoisted_23, [
                    _createTextVNode(_toDisplayString(result.syosiCd), 1),
                    _hoisted_24,
                    _createTextVNode(_toDisplayString(result.isbn) + " ", 1),
                    _hoisted_25,
                    _createVNode(_component_router_link, {
                      to: { name: 'OrderItemInfo', params: { id: result.janCd } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(result.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(result.availableAmount), 1),
                  _createElementVNode("td", _hoisted_26, [
                    _createElementVNode("span", null, _toDisplayString(result.zsNameDisplay), 1),
                    _createElementVNode("span", null, _toDisplayString(result.cutting), 1)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(result.inputSum), 1),
                  _createElementVNode("td", null, _toDisplayString(result.holdSum), 1),
                  _createElementVNode("td", null, _toDisplayString(result.returnItems), 1),
                  _createElementVNode("td", _hoisted_27, _toDisplayString(result.hontaiPrice?.toLocaleString()), 1),
                  _createElementVNode("td", _hoisted_28, [
                    (Number(result.torioki) > 0)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: ($event: any) => (openToriokiDetail(result.janCd))
                        }, _toDisplayString(result.torioki), 9, _hoisted_29))
                      : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(result.torioki), 1))
                  ]),
                  _createElementVNode("td", _hoisted_31, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "OrderSearch_Table_Input Move_With_Enter",
                      "onUpdate:modelValue": ($event: any) => ((result.orderNum) = $event),
                      tabindex: "3",
                      onFocus: ($event: any) => (focusQuantity($event, index)),
                      onChange: ($event: any) => (validateQuantity($event, index)),
                      onBlur: ($event: any) => (blurQuantity($event, index)),
                      onKeydown: [
                        _cache[27] || (_cache[27] = _withKeys(_withModifiers(($event: any) => (_unref(moveNext)($event, _unref(moveWithEnterElms))), ["exact"]), ["enter"])),
                        _cache[28] || (_cache[28] = _withKeys(_withModifiers(($event: any) => (_unref(movePrev)($event, _unref(moveWithEnterElms))), ["shift"]), ["enter"]))
                      ]
                    }, null, 40, _hoisted_32), [
                      [_vModelText, result.orderNum]
                    ]),
                    _createVNode(_component_font_awesome_icon, {
                      icon: "cart-shopping",
                      class: "OrderSearch_Icon_Cart Move_With_Enter",
                      tabindex: "3",
                      onClick: ($event: any) => (addOrderToCart(result)),
                      onKeydown: [
                        _cache[29] || (_cache[29] = _withKeys(_withModifiers(($event: any) => (_unref(moveNext)($event, _unref(moveWithEnterElms))), ["exact"]), ["enter"])),
                        _cache[30] || (_cache[30] = _withKeys(_withModifiers(($event: any) => (_unref(movePrev)($event, _unref(moveWithEnterElms))), ["shift"]), ["enter"])),
                        _withKeys(_withModifiers(($event: any) => (addOrderToCart(result)), ["exact","prevent"]), ["space"])
                      ]
                    }, null, 8, ["onClick", "onKeydown"])
                  ]),
                  _createElementVNode("td", _hoisted_33, _toDisplayString(result.series), 1),
                  _createElementVNode("td", _hoisted_34, _toDisplayString(result.itemRemarksDisplay), 1),
                  _createElementVNode("td", _hoisted_35, [
                    _createElementVNode("span", null, _toDisplayString(formatDate(result.releaseDate)), 1),
                    _createElementVNode("span", null, _toDisplayString(formatDate(result.juhanDate)), 1),
                    _createElementVNode("span", null, _toDisplayString(formatDate(result.kaisoDate)), 1)
                  ]),
                  _createElementVNode("td", _hoisted_36, [
                    _createTextVNode(_toDisplayString(result.author1), 1),
                    _hoisted_37,
                    _createTextVNode(" " + _toDisplayString(result.author2), 1),
                    _hoisted_38,
                    _createTextVNode(" " + _toDisplayString(result.author3), 1),
                    _hoisted_39
                  ])
                ], 2))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (!_unref(search_result).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, " ※検索結果はありません "))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(OrderFooter, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      fromOrderSearch: _unref(fromOrderSearch),
      countSelectedSyosi: countSelectedSyosi.value,
      onChange: _unref(selectAll),
      onUpdateNum: _unref(updateNum),
      onAddCart: addOrderToCart
    }, null, 8, ["isActive_SidebarFlg", "fromOrderSearch", "countSelectedSyosi", "onChange", "onUpdateNum"])
  ], 2))
}
}

})